import { SuccessTicketStatusType } from '../../../../../../types';
import { TicketSuccessStatusNew, TicketSuccessStatusOld } from './modules';

type Props = {
    onClose: () => void;
    successData: SuccessTicketStatusType;
};

const TicketSuccessStatus = ({ onClose, successData }: Props) => {
    switch (successData.type) {
        case 'new':
            return <TicketSuccessStatusNew successData={successData} onClose={onClose} />;
        case 'old':
            return <TicketSuccessStatusOld successData={successData} onClose={onClose} />;
    }
};

export default TicketSuccessStatus;
